import React from "react";
import PropTypes from "prop-types";

import Box from "../box/index.js";
import Columns from "../columns/index.js";

import styles from "./styles.module.scss";

function Forms({
  disabled = false,
  label = null,
  max = 20,
  min = 0,
  name = null,
  numberOfColumns = 3,
  onChange = () => {},
  options = [],
  step = 1,
  tabIndex = 0,
  type = "text",
  value = 5
}) {
  const input = (type) => {
    switch (type) {
      case "text":
        return (
          <Box
            corners="rounded"
            element="input"
            name={name}
            onChange={onChange}
            tabIndex={tabIndex}
            type="text"
            value={value}
            width="full"
          />
        );
      case "range":
        return (
          <Box
            corners="rounded"
            element="input"
            min={min}
            max={max}
            name={name}
            onChange={onChange}
            step={step}
            tabIndex={tabIndex}
            type="range"
            value={value}
            width="full"
          />
        );
      case "checkboxGroup":
        return (
          <Columns gap={"sm"} numberOfColumns={numberOfColumns}>
            {options.map((option) => (
              <label key={option.value}>
                <Box
                  checked={value.includes(option.value)}
                  disabled={disabled}
                  corners="rounded"
                  element="input"
                  name={name}
                  onChange={onChange}
                  tabIndex={tabIndex}
                  type="checkbox"
                  value={option.value}
                />
                {option.label}
              </label>
            ))}
          </Columns>
        );
      case "checkbox":
        return (
          <label>
            <Box
              checked={value}
              corners="rounded"
              disabled={disabled}
              element="input"
              name={name}
              onChange={onChange}
              tabIndex={tabIndex}
              type={type}
              value={value}
            />
            {label}
          </label>
        );
      case "radio":
        return (
          <Columns gap={"sm"} numberOfColumns={numberOfColumns}>
            {options.map((option) => (
              <label key={option.value}>
                <input
                  className={styles.input}
                  checked={value === option.value}
                  disabled={disabled}
                  name={name}
                  onChange={onChange}
                  type="radio"
                  value={option.value}
                />
                {option.label}
              </label>
            ))}
          </Columns>
        );
      case "select":
        return (
          <Box
            className={styles.select}
            disabled={disabled}
            element="select"
            name={name}
            onChange={onChange}
            tabIndex={tabIndex}
            value={value}
            width="full"
          >
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </Box>
        );
      case "color":
        return <input type="color" name={name} />;
      case "date":
        return <input type="date" name={name} />;
      case "time":
        return <input type="time" name={name} />;
      case "datetime-local":
        return <input type="datetime-local" name={name} />;
      case "month":
        return <input type="month" name={name} />;
      case "week":
        return <input type="week" name={name} />;
      case "number":
        return <input type="number" name={name} />;
      case "email":
        return <input type="email" name={name} />;
      case "url":
        return <input type="url" name={name} />;
      case "search":
        return <input type="search" name={name} />;
      case "tel":
        return <input type="tel" name={name} />;
      case "password":
        return <input type="password" name={name} />;
      default:
        return <input type="text" name={name} />;
    }
  };

  return (
    <div>
      {label && <label htmlFor={name}>{label}</label>}
      {input(type)}
    </div>
  );
}

Forms.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ])
    })
  ),
  tabIndex: PropTypes.number,
  type: PropTypes.oneOf([
    "text",
    "range",
    "checkbox",
    "radio",
    "select",
    "color",
    "date",
    "time",
    "datetime-local",
    "month",
    "week",
    "number",
    "email",
    "url",
    "search",
    "tel",
    "password"
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.array
  ])
};

export default Forms;
